import {useSelector} from 'react-redux';

/**
 * The companies the current user belongs to.
 * @returns {Array<Object>} The user's companies.
 */
export const useUserCompanies = () => useSelector(state => state.user.companies);
